export const validatePhone = (phone) => {
  if (!phone) return 'Phone number is required';
  const cleaned = String(phone).replace(/\D/g, '');
  if (cleaned.length < 10 || cleaned.length > 12) return 'Invalid phone number';
  return '';
};

export const validateEmail = (email) => {
  if (!email) return 'Email is required';
  const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (!re.test(email)) return 'Invalid email address';
  return '';
};

export const validateRequired = (value, fieldName = 'Field') => {
  if (value === undefined || value === null) return `${fieldName} is required`;
  if (typeof value === 'string' && !value.trim()) return `${fieldName} is required`;
  return '';
};

export const validateNumber = (value, fieldName = 'Field', min, max) => {
  if (value === undefined || value === null || value === '') return `${fieldName} is required`;
  const num = Number(value);
  if (isNaN(num)) return `${fieldName} must be a number`;
  if (min !== undefined && num < min) return `${fieldName} must be at least ${min}`;
  if (max !== undefined && num > max) return `${fieldName} must be at most ${max}`;
  return '';
};

export const validateUrl = (url) => {
  if (!url) return '';
  try {
    new URL(url);
    return '';
  } catch {
    return 'Invalid URL';
  }
};
